var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoteControlsMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34,41H14V13c0-1.6542969,1.3457031-3,3-3h11V8H17c-2.7568359,0-5,2.2431641-5,5v30c0,2.7568359,2.2431641,5,5,5h14 c2.7568359,0,5-2.2431641,5-5V16h-2V41z M31,46H17c-1.6542969,0-3-1.3457031-3-3h20C34,44.6542969,32.6542969,46,31,46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0v2c0.3555908,0,0.7055664,0.0228882,1.0533447,0.0533447 c5.7769775,0.5055542,10.3877563,5.116333,10.8933105,10.8933105C41.9771118,13.2944336,42,13.6444092,42,14h2 C44,6.2802734,37.7197266,0,30,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7283325,4.7283325C32.5747681,4.2626953,31.3182983,4,30,4v2c0.3678589,0,0.7271729,0.0336914,1.0819702,0.0819702 c3.545105,0.4827271,6.3533325,3.2909546,6.8360596,6.8360596C37.9663086,13.2728271,38,13.6321411,38,14h2 c0-1.3182983-0.2626953-2.5747681-0.7283325-3.7283325C38.2553711,7.7541504,36.2458496,5.7446289,33.7283325,4.7283325z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,8v2c0.4230347,0,0.8230591,0.0838623,1.2060547,0.2060547 c1.2312012,0.3928223,2.1950684,1.3566895,2.5878906,2.5878906C33.9161377,13.1769409,34,13.5769653,34,14h2 C36,10.6914062,33.3085938,8,30,8z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 14,
    r: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteControlsMedium);
export default __webpack_public_path__ + "static/media/remote-controls--medium.5da4f7eaa34c951005a84d884c3270ee.svg";
export { ForwardRef as ReactComponent };